import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollChangeRequestImplEncoder } from "../../encoder/FwdRollChangeRequestImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollChangeRequest } from "../FwdRollChangeRequest";

export class FwdRollChangeRequestImpl extends ConcreteEncodable implements FwdRollChangeRequest {
  public static enType: string = "com.bcdfx.model.event.FwdRollChangeRequestImpl";

  /*FID=1*/
  public changes: Array<CubiqTS.FwdRollChange> | null = null;
  /*FID=2*/
  public portfolioId: string;
  /*FID=3*/
  public resetFwdChanges: boolean;
  /*FID=4*/
  public refreshPoints: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollChangeRequestImplEncoder.Instance;
    this.setEncodableType(FwdRollChangeRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "FwdRollChangeRequestImpl[" +
      "changes=" +
      this.changes +
      "portfolioId=" +
      this.portfolioId +
      "resetFwdChanges=" +
      this.resetFwdChanges +
      "refreshPoints=" +
      this.refreshPoints +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
